import { apiClient } from './apiClient.js';

export const api = {
  // Auth
  login: (email, password) =>
    apiClient.post('/auth/login', { email, password }),

  register: (data) =>
    apiClient.post('/auth/register', data),

  getMe: () =>
    apiClient.get('/auth/me'),

  // PG
  createPG: (data) =>
    apiClient.post('/pgs', data),

  getPGs: () =>
    apiClient.get('/pgs'),

  getPG: (id) =>
    apiClient.get(`/pgs/${id}`),

  updatePG: (id, data) =>
    apiClient.put(`/pgs/${id}`, data),

  deletePG: (id) =>
    apiClient.delete(`/pgs/${id}`),

  getPendingRents: (pgId) =>
    apiClient.get(`/pgs/${pgId}/pending-rents`),

  // Floor
  createFloor: (data) =>
    apiClient.post('/floors', data),

  updateFloor: (id, data) =>
    apiClient.put(`/floors/${id}`, data),

  getFloors: (pgId) =>
    apiClient.get(`/floors/${pgId}`),

  deleteFloor: (id) =>
    apiClient.delete(`/floors/${id}`),

  // Room
  createRoom: (data) =>
    apiClient.post('/rooms', data),

  getRooms: (floorId) =>
    apiClient.get(`/rooms/${floorId}`),

  updateRoom: (id, data) =>
    apiClient.put(`/rooms/${id}`, data),

  deleteRoom: (id) =>
    apiClient.delete(`/rooms/${id}`),

  // Bed
  getBeds: (roomId) =>
    apiClient.get(`/beds/${roomId}`),

  getVacantBeds: (pgId) =>
    apiClient.get(`/beds/pg/${pgId}/vacant`),

  // Tenant
  createTenant: (data) =>
    apiClient.post('/tenants', data),

  getTenants: (pgId) =>
    apiClient.get(`/tenants/${pgId}`),

  getTenantDetail: (tenantId) =>
    apiClient.get(`/tenants/detail/${tenantId}`),

  transferTenant: (tenantId, newBedId) =>
    apiClient.post(`/tenants/${tenantId}/transfer`, null, {
      params: { newBedId: newBedId }
    }),

  vacateTenant: (tenantId, vacateDate, deductions) =>
    apiClient.post(`/tenants/${tenantId}/vacate`, null, {
      params: { vacateDate: vacateDate, deductions }
    }),

  // Demo
  seedDemoData: () =>
    apiClient.post('/seed-demo-data', {}),

  // Ledger
  getTenantLedger: (tenantId) =>
    apiClient.get(`/ledger/${tenantId}`),

  // Payment
  createPayment: (data) =>
    apiClient.post('/payments', data),

  // Charges
  generateCharges: (pgId, month) =>
    apiClient.post(`/charges/generate/${pgId}`, null, {
      params: { month }
    }),

  getTenantCharges: (tenantId) =>
    apiClient.get(`/charges/${tenantId}`),

  // Expense
  createExpense: (data) =>
    apiClient.post('/expenses', data),

  getExpenses: (pgId) =>
    apiClient.get(`/expenses/${pgId}`),

  getExpenseMonthlySummary: (pgId, month) =>
    apiClient.get(`/expenses/${pgId}/monthly-summary`, {
      params: { month }
    }),

  // Dashboard
  getDashboard: (pgId) =>
    apiClient.get(`/dashboard/${pgId}`),

  getDashboardFinancial: (pgId, month) =>
    apiClient.get(`/dashboard/${pgId}/financial`, {
      params: { month }
    })
};
